import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/169.png'


const _withScopeId = n => (_pushScopeId("data-v-13b9fcb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-default dark"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "album"
}
const _hoisted_4 = {
  key: 0,
  class: "name"
}
const _hoisted_5 = { class: "lesson" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "author"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_9 = { class: "player" }
const _hoisted_10 = { class: "video-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = { class: "video" }
const _hoisted_13 = {
  key: 0,
  class: "not-found"
}
const _hoisted_14 = { class: "tip" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "icon i-bofang"
}
const _hoisted_18 = { class: "toolbar" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-shoucang" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-pen" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tip" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-shipinxiazai" }, null, -1))
const _hoisted_23 = { class: "right drop-enter" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon i-all",
  style: {"font-size":"18px"}
}, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "drop"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-loop-once" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-loop_one" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-loop_one" }, null, -1))
const _hoisted_29 = ["href"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "side" }
const _hoisted_32 = { class: "title" }
const _hoisted_33 = { class: "name line1" }
const _hoisted_34 = { class: "author line1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_36 = {
  key: 1,
  class: "detail"
}
const _hoisted_37 = { class: "page-title" }
const _hoisted_38 = { class: "info" }
const _hoisted_39 = { class: "name" }
const _hoisted_40 = { class: "desc" }
const _hoisted_41 = { class: "option" }
const _hoisted_42 = { class: "option" }
const _hoisted_43 = { class: "option" }
const _hoisted_44 = { class: "option" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"left"} }, null, -1))
const _hoisted_46 = { class: "intro" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_49 = {
  key: 0,
  class: "mask"
}
const _hoisted_50 = {
  key: 1,
  class: "dialog note-writer"
}
const _hoisted_51 = { class: "input" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = { class: "submit" }
const _hoisted_54 = {
  key: 2,
  class: "dialog reporter"
}
const _hoisted_55 = { style: {"font-size":"18px"} }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = ["placeholder"]

import tongjiApi from '@/api/tongjiApi'
import api from '@/api/fyApi';
import userApi from '@/api/userApi'
import backMusic from '@/store/backMusic';
import device from '@/store/device';
import moviePlayer, { State } from '@/store/channels/movie-player';
import favorites from '@/store/mine/favorites';
import user from '@/store/user';
import Avatar from '@/views/components/Avatar.vue';
import ImageBackDiv from '@/views/components/ImageBackDiv.vue';
import Poster from '@/views/components/Poster.vue';
import * as filters from '@/views/filters';
import * as links from '@/views/links';
import ViewContext from '@/views/ViewContext';
import { version, app, device as device0 } from '@/config'
import QRCode from 'qrcode';
import { computed, inject, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';
import { setting } from '@/config';
import { doDownload, isMobile } from '@/common/download'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext
const store = useStore();
const route = useRoute();
const router = useRouter();
const data = computed<State>(() => store.state[moviePlayer.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const videoTitle = computed(() => {
    if (data.value.album) {
        let item = data.value.album.url_list.find(item => item.urlid == data.value.urlid)
        if (item) {
            return item.title
        }
    }
    return '';
})

const video = ref<HTMLDivElement>()
const player = ref<any>()
const playlist = ref<HTMLDivElement>()
const state = reactive({
    loopMode: '0',
    noteVisible: false,
    noteContent: '',
    noteId: 0,
    qrVisible: false,
    reporterVisible: false,
    reporterContent: '',
    reporterContact: '',
})
const canvas = ref()

onMounted(function () {
    backMusic.shutdown(store)
    if (data.value.resource) {
        createPlayer(data.value.resource.url)
    }
    window.onbeforeunload = function () {
        logPlayback()
    }
    if (isMobile() && setting.first && data.value.resource) {
        let url = 'fuyintv://tv/movie?movid=' + data.value.movid + '&urlid=' + data.value.resource.urlid
        window.location.href = url
    }
})

onBeforeUnmount(function () {
    logPlayback()
    if (player.value) {
        context.dispostAliPlayer('video', player.value)
    }
    window.onbeforeunload = null;
})

watch(() => data.value.resource, function () {
    if (data.value.resource) {
        createPlayer(data.value.resource.url)
    }
})

function onShowQr() {
    if (!doDownload()) {
        state.qrVisible = true
        // let text = `https://mfuyin.net/index.html?#/movie/${data.value.movid}?urlid=${data.value.urlid}`
        let text = 'https://www.fytvapp.net/'
        setTimeout(() => {
            //@ts-ignore
            QRCode.toCanvas(canvas.value, text, {
                width: 128,
                height: 128
            }, function (error: any) {
                if (error) console.error(error)
            })
        }, 50);
        document.onmousedown = function () {
            document.onmousedown = null;
            state.qrVisible = false;
        }
    }
}

async function onFavorite() {
    if (user.online(store) && data.value.album) {
        try {
            if (data.value.isFavorite) {
                await favorites.removeId(store, data.value.album.movid)
            } else {
                await favorites.addId(store, data.value.album.movid)
            }
            data.value.isFavorite = !data.value.isFavorite
            // device.toast(store, data.value.isFavorite ? '添加成功' : '删除成功');
        } catch (e) {
            // device.toast(store, data.value.isFavorite ? '删除失败' : '添加失败');
        }
    }
}

function logPlayback() {
    if (user.online(store, false)) {
        if (player.value && data.value.resource) {
            moviePlayer.logPlayback(store, data.value.resource.urlid, player.value.getCurrentTime() || 0, data.value.resource.movid)
        }
    }
}

function createPlayer(source: string) {
    context.dispostAliPlayer('video', player.value)
    if (!source) {
        return
    }
    player.value = context.createAliPlayer('video', source, function () {
        if (data.value.urlid == route.params.url && route.query.t) {
            player.value.seek(route.query.t)
        }
    }, {
        auto: data.value.played || !window.isMac,
        poster: window.isMac ? '/video.gif' : '',
        isLive: false,
        rate: true,
        isAudio: false,
    })
    player.value.on('play', () => {
        data.value.played = true
    })
    player.value.on('ended', onCurrVideoEnd)
    if (playlist.value && data.value.album) {
        let i = data.value.album.url_list.findIndex(item => item.urlid == data.value.urlid)
        playlist.value.scrollTop = i * 36;
    }
    tongjiApi.postVideo('play_movie', data.value.movid, data.value.urlid)
}
function onCurrVideoEnd() {
    if (state.loopMode && data.value.album) {
        if (state.loopMode == '0') {
            let i = data.value.album.url_list.findIndex(item => item.urlid == data.value.urlid)
            if (i < data.value.album.url_list.length - 1) {
                let next = data.value.album.url_list[i + 1]
                switchUrl(next.urlid)
            }
        } else {
            if (player.value) {
                player.value.play()
            }
        }
    }
}

async function switchUrl(urlid: ID) {
    logPlayback()
    router.push(`/channels/movie-player/${data.value.album.movid}/${urlid}.html`)
}

async function showNote() {
    if (user.online(store) && data.value.resource) {
        try {
            let last = await userApi.getNote(data.value.urlid, data.value.resource.movid)
            if (last) {
                state.noteContent = last.content
                state.noteId = last.id
            }
        } catch (e) {
            state.noteContent = '';
        } finally {
            state.noteVisible = true
        }
    }
}

async function onSaveNote() {
    if (!state.noteContent) {
        return device.toast(store, lang.value.mineText.noteError)
    }
    if (data.value.resource) {
        try {
            if (state.noteId) {
                await userApi.saveNote({
                    id: state.noteId,
                    title: data.value.resource.movie_title,
                    subtitle: data.value.resource.title,
                    content: state.noteContent
                })
            } else {
                await userApi.addNote({
                    movid: data.value.resource.movid,
                    urlid: data.value.urlid,
                    title: data.value.resource.movie_title,
                    subtitle: data.value.resource.title,
                    content: state.noteContent
                })
            }
            device.toast(store, lang.value.mineText.successSave)
            state.noteVisible = false
            state.noteContent = ''
        } catch (e) {
            device.toast(store, lang.value.mineText.errorSave)
        }
    }
}

async function showSuggest() {
    if (user.online(store)) {
        state.reporterVisible = true;
    }
}

async function onSubmitSuggest() {
    if (!state.reporterContent) {
        device.toast(store, lang.value.mineText.contentError)
        return
    }
    if (!state.reporterContact) {
        device.toast(store, lang.value.mineText.contactError)
        return
    }
    let body = {
        contact: state.reporterContact,
        content: state.reporterContent,
        version,
        device: device0,
        app,
        ua: window.navigator.userAgent,
        movid: data.value.movid,
        urlid: data.value.urlid,
    }
    await userApi.postSuggest(body)
    device.toast(store, lang.value.mineText.successSubmit)
    state.reporterVisible = false
    state.reporterContact = '';
    state.reporterContent = ''
}

function onCancelReport() {
    state.reporterVisible = false
    state.reporterContact = '';
    state.reporterContent = ''
}

async function onDownload() {
    if (user.online(store) && data.value.urlid) {
        let { url } = await api.getMovieResourceUrl(data.value.movid, data.value.urlid, 3)
        if (url && /^https?:\/\//i.test(url)) {
            let a = document.createElement('a')
            a.href = url;
            a.target = "_blank"
            a.click();
        }
        tongjiApi.postVideo('down_movie', data.value.movid, data.value.urlid)
    }
}

function onLoopChange() {
    switch (state.loopMode) {
        case '0':
            state.loopMode = '1'
            break;
        case '1':
            state.loopMode = ''
            break;
        default:
            state.loopMode = '0'
            break;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ImageBackDiv, {
      url: _unref(data).album?.thumb
    }, {
      default: _withCtx(() => [
        (_unref(data).resource)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_unref(data).album)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_unref(data).album.title) + " ", 1),
                      (_unref(data).album.subtitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(data).album.subtitle) + ")", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(lang).movieText.player_current) + "：" + _toDisplayString(_unref(videoTitle)), 1),
                  (_unref(data).album && _unref(data).album.speaker_info)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(Avatar, {
                          url: _unref(data).album.speaker_info.thumb
                        }, null, 8, ["url"]),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_unref(data).album.speaker_info.name) + " ", 1),
                          _hoisted_8
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      ref_key: "video",
                      ref: video,
                      id: "video"
                    }, null, 512),
                    (_unref(data).resource && !_unref(data).resource.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(lang).movieText.album_notfound), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "playlist",
                  ref_key: "playlist",
                  ref: playlist
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(lang).movieText.player_list), 1),
                  (_unref(data).album)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).album?.url_list, (item, i) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: _normalizeClass(["item", { on: item.urlid == _unref(data).urlid }]),
                            onClick: ($event: any) => (switchUrl(item.urlid))
                          }, [
                            (item.urlid == _unref(data).urlid)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(item.title), 1)
                          ], 10, _hoisted_16))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("a", {
                  class: _normalizeClass({ on: _unref(data).isFavorite }),
                  onClick: onFavorite
                }, [
                  _hoisted_19,
                  _createTextVNode(_toDisplayString(_unref(lang).movieText.player_favorite), 1)
                ], 2),
                _createElementVNode("a", { onClick: showNote }, [
                  _hoisted_20,
                  _createTextVNode(_toDisplayString(_unref(lang).movieText.player_note), 1)
                ]),
                _createElementVNode("a", { onClick: showSuggest }, [
                  _hoisted_21,
                  _createTextVNode(_toDisplayString(_unref(lang).movieText.player_suggest), 1)
                ]),
                _createElementVNode("a", {
                  class: "right",
                  onClick: onDownload
                }, [
                  _hoisted_22,
                  _createTextVNode(_toDisplayString(_unref(lang).movieText.player_download), 1)
                ]),
                _createElementVNode("a", _hoisted_23, [
                  _createElementVNode("a", { onClick: onShowQr }, [
                    _hoisted_24,
                    _createTextVNode(_toDisplayString(_unref(lang).movieText.player_phone), 1)
                  ]),
                  (_unref(state).qrVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("canvas", {
                          ref_key: "canvas",
                          ref: canvas
                        }, null, 512)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_unref(state).loopMode == '0')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "right on",
                      onClick: onLoopChange
                    }, [
                      _hoisted_26,
                      _createTextVNode(_toDisplayString(_unref(lang).movieText.player_play_list), 1)
                    ]))
                  : (_unref(state).loopMode == '1')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "right on",
                        onClick: onLoopChange
                      }, [
                        _hoisted_27,
                        _createTextVNode(_toDisplayString(_unref(lang).movieText.player_play_one_loop), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "right",
                        onClick: onLoopChange
                      }, [
                        _hoisted_28,
                        _createTextVNode(_toDisplayString(_unref(lang).movieText.player_play_one_loop), 1)
                      ]))
              ]),
              (_unref(data).resource && _unref(data).resource.ad)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "banners",
                    style: _normalizeStyle(_unref(filters).bg(_unref(data).resource.ad.image_src)),
                    href: _unref(data).resource.ad.image_url
                  }, [
                    _createElementVNode("img", {
                      src: _unref(data).resource.ad.image_src
                    }, null, 8, _hoisted_30)
                  ], 12, _hoisted_29))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(lang).movieText.player_recommend), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).album?.recommend_list, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    class: "tj link",
                    to: _unref(links).album(item.movid)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Poster, {
                        url: item.thumb,
                        theme: "album"
                      }, null, 8, ["url"]),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_34, _toDisplayString(item.speaker), 1),
                      _hoisted_35
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 256))
              ]),
              (_unref(data).album)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(lang).movieText.player_intro), 1),
                    _createElementVNode("div", null, [
                      _createVNode(Poster, {
                        url: _unref(data).album.thumb,
                        theme: "album"
                      }, null, 8, ["url"]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, "《" + _toDisplayString(_unref(data).album.title) + "》", 1),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", null, _toDisplayString(_unref(data).album.subtitle), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(lang).movieText.player_category) + "：" + _toDisplayString(_unref(data).album.category_info[0].name), 1),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(lang).movieText.player_source) + "：" + _toDisplayString(_unref(data).album.source), 1),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(lang).movieText.player_language) + "：" + _toDisplayString(_unref(data).album.language), 1),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(lang).movieText.player_author) + "：" + _toDisplayString(_unref(data).album.speaker), 1)
                      ]),
                      _hoisted_45
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", {
                        class: "html",
                        innerHTML: _unref(data).album.content
                      }, null, 8, _hoisted_47)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_48
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["url"]),
    (_unref(state).noteVisible || _unref(state).reporterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49))
      : _createCommentVNode("", true),
    (_unref(state).noteVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("a", {
            class: "icon i-guanbi close c-thirdary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).noteVisible = false))
          }),
          _createElementVNode("div", _hoisted_51, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).noteContent) = $event)),
              placeholder: _unref(lang).mineText.notePlaceholder
            }, null, 8, _hoisted_52), [
              [_vModelText, _unref(state).noteContent]
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("a", {
              class: "btn red",
              onClick: onSaveNote
            }, _toDisplayString(_unref(lang).mineText.save), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(data).album && _unref(state).reporterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("a", {
            class: "icon i-guanbi close c-thirdary",
            onClick: onCancelReport
          }),
          _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(data).album.title) + " " + _toDisplayString(_unref(videoTitle)), 1),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).reporterContent) = $event)),
              placeholder: _unref(lang).mineText.contentPlaceHolder
            }, null, 8, _hoisted_56), [
              [_vModelText, _unref(state).reporterContent]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).reporterContact) = $event)),
              placeholder: _unref(lang).mineText.contactPlaceHolder
            }, null, 8, _hoisted_57), [
              [_vModelText, _unref(state).reporterContact]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              class: "btn red",
              onClick: onSubmitSuggest
            }, _toDisplayString(_unref(lang).mineText.submit), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})